import _ from 'lodash';
import {
  getRequest,
  postRequest,
  patchRequest
} from '../../Common/network-call';
import {
  LOCAL_TIMEZONE,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const FETCH_MEETINGS = 'FETCH_MEETINGS';
export const SESSION_MEETINGS = 'SESSION_MEETINGS';
export const MEETING_MODAL = 'MEETING_MODAL';
export const MEETING_SETTING_OPEN = 'MEETING_SETTING_OPEN';
export const MEETING_SETTINGS = 'MEETING_SETTINGS';
export const MEETING_SCHEDULE_DATES = 'MEETING_SCHEDULE_DATES';

export const fetchMeetingScheduleDates = (
  session,
  extra = { appTabId: null },
  callback = null
) => {
  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid=${extra?.appTabId})AND(isactive=1))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.scheduledates}?fields=${FIELDS.scheduledates.minInfo}&filter=${fetchFilter}`;

  return dispatch => {
    dispatch({ type: MEETING_SCHEDULE_DATES, payload: [] });
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        const dates = !_.isEmpty(res?.resource)
          ? _.chain(res?.resource)
              .map('scheduledate')
              .sort()
              .value()
          : [];
        dispatch({ type: MEETING_SCHEDULE_DATES, payload: dates });
        callback && callback({ success: 0, data: dates, error: null });
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

export const getSessionMeetings = (session, appTabid) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.session.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.getCommon.session.payload);
  postBody.apptabid = appTabid;

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        dispatch({
          type: SESSION_MEETINGS,
          payload: res.resource
        });
      },
      error => {}
    );
  };
};

export const fetchMeetings = (session, callback = null) => {
  const filter = encodeURI(
    `((eventid=${session.eventid})AND(status!=cancelled)AND((user1=${session.userid})OR(user2=${session.userid})))`
  );
  const fetchRelated = `appuser_by_user1,appuser_by_user2&appuser_by_user1.fields=${FIELDS.appuser.relatedInfo}&appuser_by_user2.fields=${FIELDS.appuser.relatedInfo}`;
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.meetingnew}?filter=${filter}&related=${fetchRelated}&order=${FETCH_ORDERS.meetingnew}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({
          type: FETCH_MEETINGS,
          payload: res.resource
        });
        callback && callback({ success: 1, data: res?.resource, error: null });
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchMeetingDetails = (session, id, callback) => {
  const fetchFilter = encodeURI(`((eventid=${session.eventid})AND(id=${id}))`);
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.meetingnew}?filter=(${fetchFilter})`;
  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback &&
          callback({ success: 1, data: res?.resource?.[0], error: null });

        dispatch(fetchMeetings(session));
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchMeetingSlots = (
  session,
  extra = { receiver: null },
  callback
) => {
  if (_.isNil(extra?.receiver))
    return dispatch => callback({ success: 0, response: null, error: null });

  const postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.meetingSlots.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.meetingSlots.payload);
  postBody.eventid = session?.eventid;
  postBody.sender = session?.userid;
  postBody.receiver = Number(extra?.receiver);

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, response: res.resource, error: null });
      },
      error => {
        callback({ success: 0, response: null, error });
      }
    );
  };
};

export const scheduleMyMeeting = (
  session,
  extra = { data: null, isUpdate: false },
  callback
) => {
  if (_.isEmpty(extra?.data))
    return dispatch =>
      callback({ success: 0, data: null, message: 'Missing params.' });

  const postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.postCommon.scheduleMeetingPrivate.endpoint}`;
  const baseDataPayload = _.cloneDeep(
    !extra?.isUpdate
      ? SCRIPTS.postCommon.scheduleMeetingPrivate.payload.data.create
      : SCRIPTS.postCommon.scheduleMeetingPrivate.payload.data.update
  );
  const payloadBody = {
    data: {
      ...baseDataPayload,
      eventid: session?.eventid,
      starttime: extra?.data?.starttime,
      endtime: extra?.data?.endtime,
      title: extra?.data?.title,
      description: extra?.data?.description,
      location: extra?.data?.location,
      ...(extra?.data?.linked_track && {
        linked_track: extra.data.linked_track
      }),
      ...(!extra?.isUpdate
        ? { user1: extra?.data?.user1, user2: extra?.data?.user2 }
        : { status: extra?.data?.status, id: extra?.data?.id })
    },
    other: SCRIPTS.postCommon.scheduleMeetingPrivate.payload.other
  };

  return dispatch => {
    postRequest(
      postUrl,
      payloadBody,
      session,
      dispatch,
      res => {
        const id = res?.resource?.[0]?.id;
        if (id) {
          dispatch(
            fetchMeetingDetails(session, id, fetchRes => {
              if (fetchRes?.success && !_.isEmpty(fetchRes?.data))
                callback({ success: 1, data: fetchRes?.data, error: null });
              else
                callback({
                  success: 0,
                  data: res,
                  error: 'Error in fetch after patch.'
                });
            })
          );
        } else {
          callback({ success: 0, data: res, error: 'Error retrieving id.' });
        }
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchMeetingSetting = (session, callback = null) => {
  let filter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid}))`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.meetingsettings}?filter=(${filter})&limit=1`;
  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        const result = _.isEmpty(data.resource[0])
          ? {
              id: 0,
              duration: 30,
              breaktime: 15,
              autoconfirm: true,
              schedule: [],
              timezone: LOCAL_TIMEZONE
            }
          : {
              ...data.resource[0],
              schedule: JSON.parse(data.resource[0].schedule ?? '[]'),
              timezone: LOCAL_TIMEZONE
            };
        dispatch({
          type: MEETING_SETTINGS,
          payload: result
        });
        callback &&
          callback({
            success: 1,
            data: result,
            response: data?.resource,
            error: null
          });
      },
      error => {
        callback && callback({ success: 0, data: null, response: null, error });
      }
    );
  };
};

export const saveMeetingSetting = (data, session, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.meetingsettings}`;
  if (data.id != 0)
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.meetingsettings}/${data.id}`;
  let body = {
    resource: [
      {
        eventid: session.eventid,
        appuserid: session.userid,
        ..._.omit(data, ['id']),
        schedule: JSON.stringify(data.schedule)
      }
    ]
  };

  if (data.id == 0) {
    return dispatch => {
      postRequest(
        url,
        body,
        session,
        dispatch,
        response => {
          callback({ success: 1, response: response });
        },
        error => {
          callback({ success: 0, error: error });
        }
      );
    };
  } else {
    return dispatch => {
      patchRequest(
        url,
        {
          ..._.omit(data, ['appuserid', 'id']),
          schedule: JSON.stringify(data.schedule)
        },
        session,
        dispatch,
        response => {
          callback({ success: 1, response: response });
        },
        error => {
          callback({ success: 0, error: error });
        }
      );
    };
  }
};

export const clearMeeting = () => {
  return dispatch => {
    dispatch({ type: FETCH_MEETINGS, payload: { data: [], count: 0 } });
  };
};

export function openMeetingModal(value) {
  return dispatch => {
    dispatch({ type: MEETING_MODAL, payload: value });
  };
}

export const openMeetingSettings = value => {
  return dispatch => {
    dispatch({ type: MEETING_SETTING_OPEN, payload: value });
  };
};

export const updateSetting = value => {
  return dispatch => {
    dispatch({ type: MEETING_SETTINGS, payload: value });
  };
};
